import { apiClient } from '@/lib/apiClient';

export const NOTIFICATIONS_UPDATED_EVENT = 'reshai:notifications-updated';

export function dispatchNotificationsUpdated() {
  window.dispatchEvent(new CustomEvent(NOTIFICATIONS_UPDATED_EVENT));
}

export async function markNotificationsReadByKind(kind) {
  try {
    await apiClient.post('/notifications/read-by-kind', { kind });
    dispatchNotificationsUpdated();
  } catch {
    /* ignore */
  }
}

export async function markFeedbackNotificationsRead() {
  return markNotificationsReadByKind('educator_feedback');
}
